import { gql } from '@apollo/client';

export const getMachineDetailsInformation = gql`
  query MachineDetailsInformation($id: ID!) {
    getMachine(id: $id) {
      id
      alias
      materialNumber
      serialNumber
      thumbnail
      lastConnectedAt
      health
      status
      location {
        name
        longitude
        latitude
        northLatitude
        eastLongitude
        southLatitude
        westLongitude
      }
      facility
      object
      firstActivationDate
      batteryLevel
      softwareVersion
    }
  }
`;

export const listMachineSuggestedFieldValues = gql`
  query listMachineSuggestedFieldValues {
    listMachineSuggestedFieldValues {
      facility
      object
    }
  }
`;
